export default __webpack_public_path__ + "static/media/profile.4a169215.jpg";